import React, { ReactNode } from 'react';
import { SalesContractFormInterface } from '../../../../../../pages/dashboard/tradedocuments/tradeDocumentTypes/SslesContracyInterface';
import FormFooter from '../../../common/FormFooter';
import StepOne from './StepOne';
import StepTwo from './StepTwo';

const SalesContactMobileForm = ({
    error,
    updateField,
    payload,
    loading,
    errors,
    shippingLines,
    corporatePartners,
    loadingCorporatepartners,
    setShowAddPartner,
    isLoadingShippingLines,
    commodityFields,
    updateCommodityField,
    removeCommodityField,
    addCommodityField,
    commoditiesList,
    isLoadingCommodities,
    setSignatureUrlBase64Exporter,
    signatureUrlBase64Exporter,
    activeStep,
    setActiveStep,
    onSaveOnlyAction,
    showPreview,
    setShowPreview
}: SalesContractFormInterface) => {
    const views: {
        [key: number]: ReactNode;
    } = {
        0: (
            <StepOne
                {...{
                    updateField,
                    payload,
                    corporatePartners,
                    errors,
                    loadingCorporatepartners,
                    setShowAddPartner,
                    shippingLines,
                    isLoadingShippingLines,
                    commodityFields,
                    updateCommodityField,
                    removeCommodityField,
                    addCommodityField,
                    commoditiesList,
                    isLoadingCommodities
                }}
            />
        ),
        1: (
            <StepTwo
                {...{
                    setSignatureUrlBase64Exporter,
                    signatureUrlBase64Exporter,
                    updateField,
                    payload
                }}
            />
        )
    };
    return (
        <div className='lg:hidden pt-4'>
            {views[activeStep ?? 0]}

            <FormFooter
                onContinue={() => {
                    setActiveStep(activeStep + 1);
                    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                }}
                onSave={() => onSaveOnlyAction && onSaveOnlyAction()}
                onPreview={() => setShowPreview(!showPreview)}
                onGoBack={() => {
                    setActiveStep(activeStep - 1);
                    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                }}
                steps={2}
                activeStep={activeStep}
                disabled={Object.values(payload).some(
                    (item) => item === undefined
                )}
            />
        </div>
    );
};

export default SalesContactMobileForm;
